import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Typography from '@mui/material/Typography'
import { Grid, List } from '@mui/material'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import StyledLink from '../../StyledLink'
import TaxonomyListItem from './TaxonomyListItem'
import Loader from '../../Loader'
import {
  fetchOccupations,
  fetchPublishedOccupations,
  fetchPublicOccupations,
  fetchAllowedVerificationTypeGroups,
  fetchPolicies,
  fetchDocumentRuleSets,
} from '../../../redux/actions'
import {
  selectOccupationsHierarchy,
  selectOccupations,
  selectPublishedOccupations,
  selectPublicOccupations,
} from '../../../redux/selectors'
import { REORDER_AFFILIATION_TAXONOMY } from '../../../auth/policies'
import Header from '../../Header'
import { reactPlugin } from '../../../applicationInsights'

function TaxonomyPage() {
  const dispatch = useDispatch()

  const [loaded, setLoaded] = useState(false)
  const [items, setItems] = useState([])

  const occupationsHierarchy = useSelector(selectOccupationsHierarchy)
  const allOccupations = useSelector(selectOccupations)
  const publishedOccupations = useSelector(selectPublishedOccupations)
  const publicOccupations = useSelector(selectPublicOccupations)

  const getOccupations = () => {
    setLoaded(false)
    return dispatch(fetchOccupations()).then((x) => {
      setLoaded(true)
      return x
    })
  }
  const getPublishedOccupations = () => {
    setLoaded(false)
    return dispatch(fetchPublishedOccupations()).then((x) => {
      setLoaded(true)
      return x
    })
  }
  const getPublicOccupations = () => {
    setLoaded(false)
    return dispatch(fetchPublicOccupations()).then((x) => {
      setLoaded(true)
      return x
    })
  }
  const getAllowedVerificationTypeGroups = () => {
    setLoaded(false)
    return dispatch(fetchAllowedVerificationTypeGroups()).then(() => setLoaded(true))
  }
  const getPolicies = () => dispatch(fetchPolicies([REORDER_AFFILIATION_TAXONOMY]))
  const getDocumentRuleSets = () => {
    setLoaded(false)
    return dispatch(fetchDocumentRuleSets()).then(() => setLoaded(true))
  }

  const onExpandAll = () => {
    const itemsObj = {}
    allOccupations.forEach((o) => {
      if (o && o.children && o.children.length > 0) { itemsObj[o.id] = true }
    })
    setItems(itemsObj)
  }
  const onCollapseAll = () => {
    const itemsObj = {}
    allOccupations.forEach((o) => {
      if (o && o.children && o.children.length > 0) { itemsObj[o.id] = false }
    })
    setItems(itemsObj)
  }
  const toggleItem = (id) => {
    const updated = { ...items }
    updated[id] = !updated[id]
    setItems(updated)
  }

  useEffect(() => {
    getOccupations()
    getPublishedOccupations().then(() => {
      const itemsObj = {}
      publishedOccupations.forEach((o) => {
        itemsObj[o.id] = false
      })
      setItems(itemsObj)
    })
    getPublicOccupations().then(() => {
      const itemsObj = {}
      publicOccupations.forEach((o) => {
        itemsObj[o.id] = false
      })
      setItems(itemsObj)
    })
    getAllowedVerificationTypeGroups()
    getPolicies()
    getDocumentRuleSets()
  }, [])

  if (!loaded) return <Loader />
  return (
    <div style={{ minWidth: 'min-content' }}>
      <Header title="Affiliations" />
      <div>
        <Grid container style={{ paddingRight: '33px' }}>
          <Grid item style={{ flex: 1 }} />
          <Grid item>
            <StyledLink
              contents={<Typography variant="body1" style={{ color: '#00a1df' }}>Expand all</Typography>}
              disabled={Object.keys(items)
                .map((k) => items[k])
                .every((o) => o)}
              clickHandlerOnly
              onClick={() => onExpandAll()}
            />
          </Grid>
          <Grid item><Typography variant="body1" style={{ color: '#9b9b9b' }}>&nbsp;|&nbsp;</Typography></Grid>
          <Grid item>
            <StyledLink
              contents={<Typography variant="body1" style={{ color: '#00a1df' }}>Collapse all</Typography>}
              disabled={Object.keys(items)
                .map((k) => items[k])
                .every((o) => !o)}
              clickHandlerOnly
              onClick={() => onCollapseAll()}
            />
          </Grid>
        </Grid>
        <List style={{ minHeight: '100vh' }}>
          {occupationsHierarchy
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .map((o, i) => (
              <TaxonomyListItem
                key={o.id}
                index={i}
                occupation={o}
                depth={0}
                items={items}
                toggleItem={toggleItem}
                siblings={occupationsHierarchy.filter((x) => x.parentId === o.parentId)}
              />
            ))}
        </List>
      </div>
    </div>
  )
}

export default withAITracking(reactPlugin, TaxonomyPage)
